// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ReconciliationTwoToneSvg from "@fishx/icons-svg/es/asn/ReconciliationTwoTone";
import FishxIcon from '../components/FishxIcon';

var ReconciliationTwoTone = function ReconciliationTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ReconciliationTwoToneSvg
  }));
};

ReconciliationTwoTone.displayName = 'ReconciliationTwoTone';
export default React.forwardRef(ReconciliationTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ReconciliationTwoTone.js
// module id = 3982
// module chunks = 0